module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (199).dc44a06d.jpg";